import { createAsyncThunk } from "@reduxjs/toolkit";
import { ContactApi } from "api/contact";

export const getContactUs = createAsyncThunk(
  "contactUs/getContactUs",
  async (_, { rejectWithValue }) => {
    try {
      const response = await ContactApi.contactUs();
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
